(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["yaReport"] = factory();
	else
		root["yaReport"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function eventDelegate(parentSelector, targetSelector, events, foo) {
  // 触发执行的函数
  function triFunction(e) {
    // 兼容性处理
    var event = e || window.event; // 获取到目标阶段指向的元素

    var target = event.target || event.srcElement; // 获取到代理事件的函数

    var currentTarget = event.currentTarget; // 处理 matches 的兼容性

    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s);
        var i = matches.length;

        while (--i >= 0 && matches.item(i) !== this) {}

        return i > -1;
      };
    } // 遍历外层并且匹配


    while (target && target !== currentTarget) {
      // 判断是否匹配到我们所需要的元素上
      if (target && target.matches(targetSelector)) {
        var sTarget = target; // 执行绑定的函数，注意 this

        foo.call(sTarget, Array.prototype.slice.call(arguments));
      }

      target = target && target.parentNode;
    }
  } // 如果有多个事件的话需要全部一一绑定事件


  events.split('.').forEach(function (evt) {
    // 多个父层元素的话也需要一一绑定
    Array.prototype.slice.call(document.querySelectorAll(parentSelector)).forEach(function ($p) {
      $p.addEventListener(evt, triFunction);
    });
  });
}

function parseQueryString(url) {
  var pos;
  var obj = {};

  if ((pos = url.indexOf('?')) !== -1) {
    var param = url.substring(pos + 1, url.length);
    var paramArr = param.split('&');
    var keyValue = [];

    for (var i = 0, l = paramArr.length; i < l; i++) {
      keyValue = paramArr[i].split('=');
      obj[keyValue[0]] = keyValue[1];
    }
  }

  return obj;
}

function report(obj) {
  var obj = obj || {};
  var oUrl = parseQueryString(location.search);
  var pro = obj.pro;

  if (!window.YA) {
    return false;
  }

  var source = {
    pro: pro,
    // 产品给的
    pas: YA.cookie.get('username') || '',
    yyuid: YA.cookie.get('yyuid') || '',
    pageType: 'root',
    rso: oUrl.rso || '',
    rso_desc: '',
    eid: '',
    eid_desc: ''
  };

  for (var property in obj) {
    source[property] = obj[property];
  }

  window.ya = new YA(source.pro, source.pas, {
    pageType: source.pageType,
    yyuid: source.yyuid
  });
  ya.reportProductStartUp({
    pro: source.pro,
    rso: source.rso,
    rso_desc: source.rso_desc
  });
  ya.startProductHeartbeat({
    pro: source.pro,
    rso: source.rso,
    rso_desc: source.rso_desc
  });

  if (source.eid) {
    ya.reportProductEvent({
      eid: source.eid
    });
  } // 点击上报


  eventDelegate('body', '.clickstat', 'click', function () {
    var eid = this.getAttribute('eid');

    if (eid) {
      ya.reportProductEvent({
        eid: eid
      });
    }
  });
}

function getScriptCache(url, callback) {
  var head = document.getElementsByTagName('head')[0] || document.documentElement;
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.charset = 'utf-8';
  script.src = url;

  script.onload = script.onreadystatechange = function () {
    if (!script.readyState || /loaded|complete/.test(script.readyState)) {
      callback && callback();
      script.onload = script.onreadystatechange = null;

      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    }
  };

  head.insertBefore(script, null);
}

function addHandler(element, type, handler) {
  return element.addEventListener ? element.addEventListener(type, handler, false) : element.attachEvent('on' + type, handler);
}

function resetReport() {
  var _hmt = window.yaReportArr || [];

  if (_hmt.length) {
    for (var i = 0; i < _hmt.length; i++) {
      window.ya && ya.reportProductEvent(_hmt[i]);
    }
  }

  window.yaReportArr = [];

  window.yaReportArr.push = function (obj) {
    window.ya && ya.reportProductEvent(obj);
  };
}

var getYajs = function () {
  var btn = true;
  return function (obj) {
    if (btn) {
      btn = false;
      getScriptCache('https://static-jw.msstatic.com/rp/ya-huya.finall.min.js', function () {
        report(obj);
        resetReport();
      });
    }
  };
}();

function yaReport(obj) {
  addHandler(window, 'load', function () {
    getYajs(obj);
  });
  setTimeout(function () {
    getYajs(obj);
  }, 3000);
}

/* harmony default export */ __webpack_exports__["default"] = (yaReport);

/***/ })
/******/ ])["default"];
});